<div class="dialog-content primary">
  <app-npi-number *ngIf="currentStep === PharmacyDetailsStepsEnum.NpiNumber"
                  [location]="location"
                  (nextStep)="nextStep($event)"
                  (cancel)="closeForm.emit()"
  ></app-npi-number>

  <div [class.show]="currentStep === PharmacyDetailsStepsEnum.Details" class="verified-label">
    <img src="../../../../assets/icons/icon-alert-success.svg" alt="npi-success"/>
    <span>NPI verified</span>
  </div>

  <app-pharmacy-form *ngIf="currentStep === PharmacyDetailsStepsEnum.Details"
                     [location]="location"
                     (save)="savePharmacy($event)"
                     (cancel)="cancelPharmacyForm()"
  ></app-pharmacy-form>
</div>
